import { Link } from "react-router-dom";
import { products } from "./data/products";

export const ApplicationMain: React.FC = () => {
  return (
    <div
      id="application-main"
      className="div application-main"
      application-local-name="stm-corporate"
    >
      <header className="hero">
        <div className="hero-inner">
          <div className="eyebrow">Steamtown Media Limited &middot; Gilbertsville, PA</div>
          <h1 className="wordmark">
            Small studio.
            <br />
            Precision&#8209;<span>built</span> software.
          </h1>
          <p className="tagline">
            We design and ship focused apps and tools — for photographers, for
            people trying to get through their day, and for the engineering
            teams behind the scenes.
          </p>
          <div className="cta-row">
            <Link className="btn-stm btn-stm-primary" to="/apps">
              View our apps
            </Link>
            <Link className="btn-stm btn-stm-secondary" to="/contact">
              Get in touch
            </Link>
          </div>
        </div>
      </header>

      <section className="block">
        <div className="wrap">
          <h2 className="section-title">What we build</h2>
          <h3 className="section-head">Many products, one capable team.</h3>

          <div className="grid-3">
            {products.map((product) => (
              <div className="panel product-card" key={product.id}>
                <div className="icon-wrap">
                  <img src={product.icon} alt={`${product.name} app icon`} />
                </div>
                <h4>{product.name}</h4>
                <p>{product.cardSummary}</p>
                <Link className="go" to={product.path}>
                  View app &rarr;
                </Link>
              </div>
            ))}

            <div className="panel product-card">
              <div className="icon-wrap mono-mark">SE</div>
              <h4>SML Engineering</h4>
              <p>
                Our engineering and enterprise division — web tooling built for
                the teams that keep catalogs, specifications, and documentation
                straight.
              </p>
              <Link className="go" to="/engineering">
                View division &rarr;
              </Link>
            </div>
          </div>

          <div className="stat-row">
            <div className="stat-col">
              <div className="k">Small by design</div>
              <p>
                One team designs, builds, and supports every release — no
                hand-offs, no ticket queue.
              </p>
            </div>
            <div className="stat-col">
              <div className="k">Built on Apple &amp; Azure</div>
              <p>
                Native SwiftUI on iOS, iPadOS, and watchOS; React, .NET, and
                Azure for web tooling.
              </p>
            </div>
            <div className="stat-col">
              <div className="k">Shipped and supported</div>
              <p>
                Real App Store products, actively maintained — not side projects
                left to rot.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="rivet-rule">
        <div className="dot"></div>
      </div>
    </div>
  );
};
